import styled from "styled-components";

export const HidePrint = styled.div`
    @media print {
        display: none;
    }
`;
